import instance from '../utils/axios';

class ElectronicInputService {
    async getList(pageIndex, keyword, status) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime desc',
            status: status,
        }
        return await instance.post('/electronerp/elePsi/material/inputStock/getInputListForMobile', data);
    }
    async getInputDetailForMobile(pageIndex, orderId, enableSN, status) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: "skuId.psi_sku,binId.psi_warehouse_shelf_bin,advisorId.base_staff",
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime desc',
            status: status,
            orderId: orderId,
            enableSN: enableSN,
        }
        return await instance.post('/electronerp/elePsi/material/inputStock/getInputDetailForMobile', data);
    }
    async validateBinBarcode(binBarcode) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
          binBarcode: binBarcode
        }
        return await instance.post('/electronerp/elePsi/material/inputStock/validateBinBarcodeForMobile', data);
    }
    async inputForMobile(orderId, barcode, binBarcode) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
          orderId: orderId,
          barcode: barcode,
          binBarcode: binBarcode
        }
        return await instance.post('/electronerp/elePsi/material/inputStock/inputForMobile', data);
    }
    async getInputDetailQuantityForMobile(orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
          orderId: orderId,
        }
        return await instance.post('/electronerp/elePsi/material/inputStock/getInputDetailQuantityForMobile', data);
    }
    async getInputOrderStatus(orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
          orderId: orderId,
        }
        return await instance.post('/electronerp/elePsi/material/inputStock/getInputOrderStatus', data);
    }
    async updateStatusByOrderId(orderId, status) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
          orderId: orderId,
          status: status,
        }
        return await instance.post('/electronerp/elePsi/material/inputStock/updateStatusByOrderId', data);
    }
    async saveNotCodeQuantity(detailId, quantity, binBarcode) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        detailId: detailId,
        quantity: quantity,
        binBarcode: binBarcode
      }
        return await instance.post('/electronerp/elePsi/material/inputStock/saveNotCodeQuantityMobile', data);
    }
}

export default new ElectronicInputService();